import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContractConfirmationDialogBase, ContractConfirmationFacade } from '@zero/shared/feature-contract-confirmation/base';
import { ButtonComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { filter } from 'rxjs';

@Component({
  imports: [TranslocoPipe, AsyncPipe, ButtonComponent, ModalComponent],
  templateUrl: './contract-confirmation-dialog.component.html',
  styleUrls: ['./contract-confirmation-dialog.component.scss'],
})
export class ContractConfirmationDialogComponent extends ContractConfirmationDialogBase implements OnInit {
  public readonly facade = inject(ContractConfirmationFacade);
  readonly #modal = inject(NgbActiveModal);
  readonly #destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.facade.hasAccepted$
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        filter((hasAccepted) => !!hasAccepted),
      )
      .subscribe(() => this.close());
  }

  public close = (): void => this.#modal.close();
  public accept = (): void => this.facade.accept();
}
